export const LEGACY_URLS = {
  RL_INFORMATION_ANALYSIS: '/investissement/participer',
}

export const MIDDLEWARE_REDIRECTS = [
  {
    from: /^\/annonces\/?.*?$/gm,
    to: (from, route, urls) => {
      return `${urls.hpBaseUrl}/biens-rentables`
    },
    statusCode: 301,
    useResult: false,
  },
  {
    from: /^\/expert(\/?)$/gm,
    to: (from, route, urls) => urls.hpBaseUrl,
    statusCode: 301,
    useResult: false,
  },
  {
    from: /^\/marketplace(\/?)$/gm,
    to: (from, route, urls) => urls.hpBaseUrl,
    statusCode: 301,
    useResult: false,
  },
  {
    from: /^\/ou-investir\/villes\/(.*)\/([0-9]{5})\/annonce\/([0-9a-fA-F]{24})/gm,
    statusCode: 301,
    to: (from, route) => {
      return route.replace(
        /^\/ou-investir\/villes\/(.*)\/([0-9]{5})\/annonce\/([0-9a-fA-F]{24})/gm,
        '/ou-investir/annonces/$3',
      )
    },
    useResult: true,
  },
  {
    from: /^\/ou-investir\/villes\/(Paris|Marseille|Lyon)(\s|%20)[0-9]+\/([0-9]{5})(\/?)$/gm,
    statusCode: 301,
    to: (from, route, urls) => {
      return urls.hpBaseUrl + route.replace(/\/(Paris|Marseille|Lyon)(\s|%20)[0-9]+\//gm, '/$1/')
    },
    useResult: false,
  },
]
